import { render, staticRenderFns } from "./BulkPersonalizationSplit.vue?vue&type=template&id=48708f9f&scoped=true"
import script from "./BulkPersonalizationSplit.vue?vue&type=script&lang=js"
export * from "./BulkPersonalizationSplit.vue?vue&type=script&lang=js"
import style0 from "./BulkPersonalizationSplit.vue?vue&type=style&index=0&id=48708f9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48708f9f",
  null
  
)

export default component.exports